import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Ink from 'react-ink'

import * as types from '../constants/Types'
import * as resource from '../constants/Resources'
import { clearKeyboard, toggleKeyboard } from '../actions/layoutActions'
import { loginUser } from '../actions/loginActions'
import { setSelectModal, setMessageModal, setPos } from '../actions/generalActions'
import { getTranslation } from '../actions/dataActions'
import avatarUrl from '../images/avatar.png'

const UserPanel = props => {
  const {
    clearKeyboard,
    culture,
    getTranslation,
    loginUser,
    posDescription,
    posId,
    posList,
    setMessageModal,
    setPos,
    setSelectModal,
    toggleKeyboard,
    uniqueid,
    userid,
    username,
    userLabels,
    visibility,
    keyboard
  } = props;

  const handleLogin = password => {
    if (posId === 0 || posId === null) {
      setMessageModal(true, getTranslation(resource.SELECT_POS_ENVIRONMENT));
    }
    else {
      clearKeyboard();

      loginUser({
        SystemUserId: userid,
        SystemUsername: username,
        Password: password,
        PosId: posId,
        Culture: culture,
        UniqueId: uniqueid
      });      
    }
  }

  const handleLoginClick = () => handleLogin(keyboard.input);

  const showKeyboard = () => {
    toggleKeyboard(true, '#password', getTranslation(resource.PASSWORD), handleLogin, [], false);
  }

  const handlePosSelect = () => {
    let itemList = posList
      .filter(pos => pos.PosType !== types.POSTYPE_WEBSHOP)
      .map(pos => ({
        Description: pos.Description,
        ItemId: pos.PosId,
        Labels: pos.Labels
      }));
      
    if(userLabels && userLabels.length > 0) {
      itemList = itemList.filter(pos => {
        return pos.Labels.length === 0 || pos.Labels.some(posLabelId => userLabels.some(userLabelId => userLabelId === posLabelId))
      })
    }
      
    setSelectModal(itemList, true, getTranslation(resource.SELECT_POS), setPos);
  }

  return (
    <div className="userpanel" style={{ display: visibility }}>
      <div className="avatar">
        <div className="iconcircle">
          <img src={avatarUrl} alt="Avatar" className="avatarimage" />
        </div>
      </div>
      <div className="userinfo">
        <div className="username">
          {username}
        </div>
        <div className="poslabel">
          <button className="posbtn" onClick={handlePosSelect}>
            {posDescription}
            <Ink />
          </button>
        </div>
      </div>
      <div className="panelfooter">
        <div className="footercontent">
          <div className="inputfield">
            <input
              id="password"
              className="passwordfield"
              type="password"
              placeholder={getTranslation(resource.PASSWORD)}
              onClick={showKeyboard}
              readOnly="readonly"
            />
          </div>
          <button className="loginbutton" onClick={handleLoginClick}>
            {getTranslation(resource.LOGIN)}
            <Ink />
          </button>
        </div>
      </div>
    </div>
  )
}

UserPanel.propTypes = {
  username: PropTypes.string,
  userid: PropTypes.number,
  userLabels: PropTypes.array,
  visibility: PropTypes.string,
  toggleKeyboard: PropTypes.func.isRequired,
  loginUser: PropTypes.func.isRequired,
  setSelectModal: PropTypes.func.isRequired,
  setMessageModal: PropTypes.func.isRequired,
  posList: PropTypes.array,
  posId: PropTypes.number.isRequired,
  posDescription: PropTypes.string.isRequired,
  culture: PropTypes.string,
  setPos: PropTypes.func
}

const mapStateToProps = state => ({
  posList: state.generalState.posList,
  posId: state.generalState.posId,
  posDescription: state.generalState.posDescription,
  uniqueid: state.generalState.uniqueid,
  keyboard: state.layoutState.keyboard
})

export default connect(mapStateToProps,
  {
    clearKeyboard,
    toggleKeyboard,
    loginUser,
    setSelectModal,
    setMessageModal,
    setPos,
    getTranslation
  })(UserPanel);



// WEBPACK FOOTER //
// src/login/UserPanel.jsx